import { getCode as getObjectCode } from './objectCode'
const codePattern = /^([0-9]{5})(-?)([A-Z]{4})(-?)([0-9]{4})(-?)(Q[0-9]{3})$/i

function getCode (question, addSeparator) {
	const objectData = {
		curadoriaCodigo: question.curadoriaCodigo,
		tipoCodigo: question.tipoCodigo,
		codigo: question.temaCodigo,
		dtInsert: question.anoMes ? `01/${question.anoMes.substring(2, 4)}/20${question.anoMes.substring(0, 2)}` : null
	}

	const objectCode = getObjectCode(objectData, true)

	if (objectCode.error) {
		return { error: true, msg: 'Objeto sem código' }
	}

	const codigo = `${objectCode}-Q${question.codigo.trim().padStart(3, '0')}`
	return codigo
}

function formatCode (code, template) {
	let formattedCode = ''

	if (!template || template === 'without-separator') {
		formattedCode = code.replace(/-/g, '')
	} else if (template === 'with-separator') {
		formattedCode = code.replace(codePattern, '$1-$3-$5-$7')
	}

	return formattedCode
}

export { codePattern, getCode, formatCode }
